<template>
    <div v-if="true">
      <b-button v-b-modal="'myModal'" class="ml-2 btn-pill" size="sm" variant="outline-primary" >
        <i class="fa fa-plus"></i>
      </b-button>
      <b-modal
      id="myModal"
      variant="primary"
      size="lg">
        Hello From My Modal!
      </b-modal>
    </div>
</template>

<script>
    export default {
        name: "AgregarContenidoModal"
    }
</script>

<style scoped>

</style>
